import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';
import {
  SuspendDialogData,
  SuspendDialogResult,
} from '../../../Interfaces/suspend-dialog.interface';

@Component({
  selector: 'app-suspend-dialog',
  standalone: true,
  imports: [ReactiveFormsModule, MatDialogModule, MatIconModule, TranslateModule],
  templateUrl: './suspend-dialog.component.html',
  styleUrl: './suspend-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SuspendDialogComponent {
  private readonly _formBuilder = inject(FormBuilder);
  private readonly _dialogRef =
    inject<MatDialogRef<SuspendDialogComponent, SuspendDialogResult>>(MatDialogRef);

  readonly data = inject<SuspendDialogData>(MAT_DIALOG_DATA);


  readonly formGroup: FormGroup = this._formBuilder.group({
    reason: ['', [Validators.required, Validators.maxLength(255)]],
  });

  confirm(): void {
    if (!this.formGroup.valid) {
      return;
    }

    this._dialogRef.close({ reason: String(this.formGroup.value.reason).trim() });
  }

  cancel(): void {
    this._dialogRef.close();
  }
}
